import React from "react";
import DPLogo from "../assets/svgs/DP_Logo_LM_rgb.svg";
import CCDLogo from "../assets/images/CCDLogo.png";


function Journey(): JSX.Element {
  return (
    <div className="2xl:container-fluid pt-28 pb-20 ">
      <h2 className=" text-center 2xl:text-left 2xl:pl-[155px]">
        The journey of Ciphers.me
      </h2>
      <span className="border-l-2 ml-4 2x:ml-0 2xl:border-l-0 2xl:border-b-2 border-primary border-dotted"></span>
      <ol className="border-l-2 ml-4 2xl:ml-0 border-primary 2xl:flex 2xl:gap-64 2xl:justify-center 2xl:border-l-0 2xl:border-t-2  2xl:mt-[62px] ">
        <li>
          <div className="flex-start flex items-center 2xl:block ">
            <div className="-ml-[9px] 2xl:-ml-0 2xl:-mt-2 mr-3 flex h-4 w-4 items-center justify-center rounded-full bg-primary"></div>
            <p className="2xl:-mt-11 text-1 text-subtleText">October 2023</p>
            <div className="-ml-2.5 mr-3 h-2.5 w-2.5 rounded-full 2xl:ml-0 2xl:mr-0"></div>
          </div>
          <div className="ml-4 mt-4 pb-5 2xl:ml-0 2xl:w-[189px]">
            <h4 className="text-[16px] font-bold text-primary">
              Ciphers.me kicks-off with phygital crypto stamps
            </h4>
            <p className="mb-3 text-[14px] text-subtleText">
              Pre sale off the first crypto stamp by{" "}
              <a
                href="https://www.deutschepost.de/de/k/kryptomarke.html"
                target="_blank"
                rel="noreferrer"
                className="text-primary"
              >
                Deutsche Post
              </a>
            </p>
            <p className="mb-1 pl-[14px] text-[14px] text-subtleText">
              In cooperation with
            </p>
            <a
              href="https://www.deutschepost.de/de/k/kryptomarke.html"
              target="_blank"
              rel="noreferrer"
              className="text-primary"
            >
              <img src={DPLogo} className="w-[200px] " alt="DP Deutsche Post" />
            </a>
          </div>
        </li>
        <li>
          <div className="flex-start flex items-center 2xl:block ">
            <div className="-ml-[9px] 2xl:-ml-0 2xl:-mt-2 mr-3 flex h-4 w-4 items-center justify-center rounded-full bg-primary"></div>
            <p className="2xl:-mt-11 text-1 text-subtleText">November 2023</p>
            <div className="-ml-2.5 mr-3 h-2.5 w-2.5 rounded-full 2xl:ml-0 2xl:mr-0"></div>
          </div>
          <div className="ml-4 mt-4 pb-5 2xl:ml-0 2xl:w-[189px]">
            <h4 className="text-[16px] font-bold text-primary">
              Sales and distribution of crypto stamps by Deutsche Post
            </h4>
            <p className="mb-3 text-[14px] text-subtleText">
              Collect, claim and mint the Deutsche Post crypto stamps on our
              platform
            </p>
          </div>
        </li>
        <li>
          <div className="flex-start flex items-center 2xl:block ">
            <div className="-ml-[9px] 2xl:-ml-0 2xl:-mt-2 mr-3 flex h-4 w-4 items-center justify-center rounded-full bg-primary"></div>
            <p className="2xl:-mt-11 text-1 text-subtleText">January 2024</p>
            <div className="-ml-2.5 mr-3 h-2.5 w-2.5 rounded-full 2xl:ml-0 2xl:mr-0"></div>
          </div>
          <div className="ml-4 mt-4 pb-5 2xl:ml-0 2xl:w-[189px]">
            <h4 className="text-[16px] font-bold text-primary">
              The Concordium blockchain with ID-layer will become available
            </h4>
            <p className="mb-3 text-[14px] text-subtleText">
              Giving you the option to mint valuable phygital on Concordium
            </p>
            <p className="mb-1 pl-[14px] text-[14px] text-subtleText">
              In cooperation with
            </p>
            <a
              href="https://www.concordium.com/"
              target="_blank"
              rel="noreferrer"
              className="text-primary"
            >
              <img src={CCDLogo} className="w-[200px] " alt="Concordium" />
            </a>
          </div>
        </li>
        <li>
          <div className="flex-start flex items-center 2xl:block ">
            <div className="-ml-[9px] 2xl:-ml-0 2xl:-mt-2 mr-3 flex h-4 w-4 items-center justify-center rounded-full bg-primary"></div>
            <p className="2xl:-mt-11 text-1 text-subtleText">Q1 2024</p>
            <div className="-ml-2.5 mr-3 h-2.5 w-2.5 rounded-full 2xl:ml-0 2xl:mr-0"></div>
          </div>
          <div className="ml-4 mt-4 pb-5 2xl:ml-0 2xl:w-[189px]">
            <h4 className="text-[16px] font-bold text-primary">
              Introduction of new crypto stamps and other valuable phygital
              collectibles
            </h4>
            <p className="mb-3 text-[14px] text-subtleText">
              Introduction of the international Ciphers.me marketplace
            </p>
          </div>
        </li>
      </ol>
      <span className="border-l-2 2xl:border-l-0 2xl:border-t-2 border-primary border-dotted"></span>
    </div>
  );
}

export default Journey;
